<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group label="Complaint ID" label-for="complaint-id">
              <b-form-input id="complaint-id" type="text" v-model="complaint.complaintReference" readonly />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Customer" label-for="cust">
              <b-form-input id="cust" type="text" v-model="complaint.leadClientName" readonly />
            </b-form-group>
          </b-col>

          <b-col md="6">
  <b-form-group label-for="salesperson" label="Assigned to">
    <div class="form-label-group">
      <b-form-select v-model="complaint.salespersonId" :options="optionsSalesPerson" />
    </div>
  </b-form-group>
</b-col>

          <b-col md="6">
            <b-form-group label="Status" label-for="status">
              <b-form-select id="status-select" v-model="complaint.status" :options="statusOptions" required />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label-for="Open-date" label="Creation Date">
              <b-form-datepicker id="dueDate" v-model="complaint.openDate" class="mb-1" disabled />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Due Date" label-for="dueDate">
              <b-form-datepicker id="dueDate" v-model="complaint.dueDate" class="mb-1" 
                required placeholder="Select a date"  />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Priority" label-for="priority-select">
              <b-form-select id="priority-select" v-model="complaint.rating" :options="priorityOptions" required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Complaint Comment:" label-for="Description">
                <b-form-textarea id="textarea-default" placeholder="Comment" rows="3" v-model="complaint.feedbacks[0].description" required />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="justify-content-end d-flex">
            <b-button variant="primary" @click="updateComplaint">Save</b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BContainer,
  BCard,
  BSpinner,
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BFormFile,
  BFormDatepicker,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BContainer,
    BCard,
    BSpinner,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BFormFile,
    BFormDatepicker,
    BCardText,
  },
  data() {
    return {
      statusOptions: [
        { value: 'Open', text: "Open" },
        { value: 'Resolved', text: "Resolved" },
        { value: 'NotResolved', text: "Not Resolved" },
      ],
      priorityOptions: [
        { value: 'Low', text: "Low" },
        { value: 'Medium', text: "Medium" },
        { value: 'High', text: "High" },
      ],
      optionsSalesPerson: [],
      submitting: false,
      noPermission: true,
      user: null,
      id: this.$route.params.id,
    };
  },

  computed: {
    canEditDueDate() {
      return this.user && (this.user.role === 'admin' || this.user.id === this.complaint.salespersonId);
    },
    canEditStatus() {
      return this.canEditDueDate;
    },
    canEditPriority() {
      return this.canEditDueDate;
    },
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
  },
  props: {
    complaint: {
       type: Object,
       default: () => ({}),
    },

    loading: {
      type: Boolean,
      default: false,
    }
  },
  async mounted() {
    this.fetchUserData();
    
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });

     // Ensure feedbacks[0] is initialized
  if (!this.complaint.feedbacks || !this.complaint.feedbacks[0]) {
    this.$set(this.complaint, 'feedbacks', [{ description: '' }]);
  }
  },
  methods: {
    ...mapActions("complaintModule", ["updateComplaintsAction"]),

    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),

    fetchUserData() {
      const userDataString = localStorage.getItem('userData');
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        this.user = {
          id: userData.id,
          role: userData.role,
        };
        if (this.user.id === this.complaint.salespersonId) {
          this.noPermission = false;
        }
      }
    },
    success(message) {
            this.$swal({
                title: "Success!",
                text: message,
                icon: "success",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
            });
        },
        error(message) {
            this.$swal({
                title: 'Error!',
                text: message,
                icon: 'error',
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });
        },

    async updateComplaint() {
      this.submitting = true;
      try {
        const payloadEdit = {
          ...this.complaint,
        };
        console.log("🚀 ~ updateComplaint ~ payloadEdit:", payloadEdit)
        await this.updateComplaintsAction({ id: this.id, payload: payloadEdit });
        this.success('Complaint updated successfully!');
      } catch (error) {
        console.error("Error updating Complaint:", error);
        this.error(error.response.data.message);
      } finally {
        this.submitting = false;
      }
    },


  }
};
</script>
